const BabyILoveYourWay = [
	'[Verse 1]',
	'Shadows grow so long before my eyes,',
	"And they're moving, across the page",
	'Suddenly the day turns into night,',
	'Far away, from the city',
	"But don't, hesitate,",
	"cause your love, won't wait",
	'',
	'[Chorus]',
	'Ooh, baby I love your way, (everyday)',
	'Wanna tell you I love your way, (everyday)',
	'Wanna be with you night and day',
	'',
	'[Verse 2]',
	'Moon appears to shine, and light the sky,',
	'With the help, of some firefly',
	'Wonder how they have, the power to shine, shine, shine',
	'I can see them, under the pine',
	"But don't, hesitate,",
	"'cause your love, won't wait",
	'',
	'[Chorus]',
	'Ooh, baby I love your way, (everyday)',
	'Wanna tell you I love your way, (oh)',
	'Wanna be with you night and day, (oh yeah)',
	'',
	'[Verse 3]',
	'I can see the sunset in your eyes,',
	'Brown and gray, and blue besides',
	'Clouds are stalking islands in the sun,',
	'I wish I could buy one,',
	'Out of season',
	"But don't, hesitate,",
	"'Cause your love, won't wait",
	'',
	'[Chorus]',
	'Ooh, baby I love your way, (everyday)',
	'Wanna tell you I love your way',
	'Wanna be with you night and day',
	'Ooh, baby I love your way',
];

export default BabyILoveYourWay;
